// ייבוא כל האווטרים
import studentAvatar1 from '../assets/images/avatars/student/student-avatar-01.png';
import studentAvatar2 from '../assets/images/avatars/student/student-avatar-02.png';
import studentAvatar3 from '../assets/images/avatars/student/student-avatar-03.png';
import studentAvatar4 from '../assets/images/avatars/student/student-avatar-04.png';
import studentAvatar5 from '../assets/images/avatars/student/student-avatar-05.png';
import studentAvatar6 from '../assets/images/avatars/student/student-avatar-06.png';
import studentAvatar7 from '../assets/images/avatars/student/student-avatar-07.png';
import studentAvatar8 from '../assets/images/avatars/student/student-avatar-08.png';
import studentAvatar9 from '../assets/images/avatars/student/student-avatar-09.png';
import studentAvatar10 from '../assets/images/avatars/student/student-avatar-10.png';
import studentAvatar11 from '../assets/images/avatars/student/student-avatar-11.png';
import studentAvatar12 from '../assets/images/avatars/student/student-avatar-12.png';
import studentAvatar13 from '../assets/images/avatars/student/student-avatar-13.png'; 
import studentAvatar14 from '../assets/images/avatars/student/student-avatar-14.png';
import studentAvatar15 from '../assets/images/avatars/student/student-avatar-15.png';
import studentAvatar16 from '../assets/images/avatars/student/student-avatar-16.png';
import studentAvatar17 from '../assets/images/avatars/student/student-avatar-17.png';
import studentAvatar18 from '../assets/images/avatars/student/student-avatar-18.png';
import studentAvatar19 from '../assets/images/avatars/student/student-avatar-19.png';
import studentAvatar20 from '../assets/images/avatars/student/student-avatar-20.png';
import studentAvatar21 from '../assets/images/avatars/student/student-avatar-21.png';
import studentAvatar22 from '../assets/images/avatars/student/student-avatar-22.png';

import teacherAvatar1 from '../assets/images/avatars/teacher/teacher-avatar-01.png';
import teacherAvatar2 from '../assets/images/avatars/teacher/teacher-avatar-02.png';
import teacherAvatar3 from '../assets/images/avatars/teacher/teacher-avatar-03.png';
import teacherAvatar4 from '../assets/images/avatars/teacher/teacher-avatar-04.png';
import teacherAvatar5 from '../assets/images/avatars/teacher/teacher-avatar-05.png';
import teacherAvatar6 from '../assets/images/avatars/teacher/teacher-avatar-06.png';
import teacherAvatar7 from '../assets/images/avatars/teacher/teacher-avatar-07.png';
import teacherAvatar8 from '../assets/images/avatars/teacher/teacher-avatar-08.png';
import teacherAvatar9 from '../assets/images/avatars/teacher/teacher-avatar-09.png';
import teacherAvatar10 from '../assets/images/avatars/teacher/teacher-avatar-10.png';
import teacherAvatar11 from '../assets/images/avatars/teacher/teacher-avatar-11.png';
import teacherAvatar12 from '../assets/images/avatars/teacher/teacher-avatar-12.png';
import teacherAvatar13 from '../assets/images/avatars/teacher/teacher-avatar-13.png';
import teacherAvatar14 from '../assets/images/avatars/teacher/teacher-avatar-14.png';
import teacherAvatar15 from '../assets/images/avatars/teacher/teacher-avatar-15.png';
import teacherAvatar16 from '../assets/images/avatars/teacher/teacher-avatar-16.png';
import teacherAvatar17 from '../assets/images/avatars/teacher/teacher-avatar-17.png';
import teacherAvatar18 from '../assets/images/avatars/teacher/teacher-avatar-18.png';
import teacherAvatar19 from '../assets/images/avatars/teacher/teacher-avatar-19.png';
import teacherAvatar20 from '../assets/images/avatars/teacher/teacher-avatar-20.png';
import teacherAvatar21 from '../assets/images/avatars/teacher/teacher-avatar-21.png';
import teacherAvatar22 from '../assets/images/avatars/teacher/teacher-avatar-22.png';
import teacherAvatar23 from '../assets/images/avatars/teacher/teacher-avatar-23.png';
import teacherAvatar24 from '../assets/images/avatars/teacher/teacher-avatar-24.png';
import teacherAvatar25 from '../assets/images/avatars/teacher/teacher-avatar-25.png';
import teacherAvatar26 from '../assets/images/avatars/teacher/teacher-avatar-26.png';
import teacherAvatar27 from '../assets/images/avatars/teacher/teacher-avatar-27.png';
import teacherAvatar28 from '../assets/images/avatars/teacher/teacher-avatar-28.png';
import teacherAvatar29 from '../assets/images/avatars/teacher/teacher-avatar-29.png';
import teacherAvatar30 from '../assets/images/avatars/teacher/teacher-avatar-30.png';
import teacherAvatar31 from '../assets/images/avatars/teacher/teacher-avatar-31.png';
import teacherAvatar32 from '../assets/images/avatars/teacher/teacher-avatar-32.png';
import teacherAvatar33 from '../assets/images/avatars/teacher/teacher-avatar-33.png';
import teacherAvatar34 from '../assets/images/avatars/teacher/teacher-avatar-34.png';
import teacherAvatar35 from '../assets/images/avatars/teacher/teacher-avatar-35.png';
import teacherAvatar36 from '../assets/images/avatars/teacher/teacher-avatar-36.png';
import teacherAvatar37 from '../assets/images/avatars/teacher/teacher-avatar-37.png';
import teacherAvatar38 from '../assets/images/avatars/teacher/teacher-avatar-38.png';
import teacherAvatar39 from '../assets/images/avatars/teacher/teacher-avatar-39.png';
import teacherAvatar40 from '../assets/images/avatars/teacher/teacher-avatar-40.png';
import teacherAvatar41 from '../assets/images/avatars/teacher/teacher-avatar-41.png';
import teacherAvatar42 from '../assets/images/avatars/teacher/teacher-avatar-42.png';
import teacherAvatar43 from '../assets/images/avatars/teacher/teacher-avatar-43.png';
import teacherAvatar44 from '../assets/images/avatars/teacher/teacher-avatar-44.png';
import teacherAvatar45 from '../assets/images/avatars/teacher/teacher-avatar-45.png';
import teacherAvatar46 from '../assets/images/avatars/teacher/teacher-avatar-46.png';
import teacherAvatar47 from '../assets/images/avatars/teacher/teacher-avatar-47.png';
import teacherAvatar48 from '../assets/images/avatars/teacher/teacher-avatar-48.png';
import teacherAvatar49 from '../assets/images/avatars/teacher/teacher-avatar-49.png';
import teacherAvatar50 from '../assets/images/avatars/teacher/teacher-avatar-50.png';
import teacherAvatar51 from '../assets/images/avatars/teacher/teacher-avatar-51.png';
import teacherAvatar52 from '../assets/images/avatars/teacher/teacher-avatar-52.png';
import teacherAvatar53 from '../assets/images/avatars/teacher/teacher-avatar-53.png';
import teacherAvatar54 from '../assets/images/avatars/teacher/teacher-avatar-54.png';
import teacherAvatar55 from '../assets/images/avatars/teacher/teacher-avatar-55.png';
import teacherAvatar56 from '../assets/images/avatars/teacher/teacher-avatar-56.png';
import teacherAvatar57 from '../assets/images/avatars/teacher/teacher-avatar-57.png';
import teacherAvatar58 from '../assets/images/avatars/teacher/teacher-avatar-58.png';
import teacherAvatar59 from '../assets/images/avatars/teacher/teacher-avatar-59.png';
import teacherAvatar60 from '../assets/images/avatars/teacher/teacher-avatar-60.png';
import teacherAvatar61 from '../assets/images/avatars/teacher/teacher-avatar-61.png';
import teacherAvatar62 from '../assets/images/avatars/teacher/teacher-avatar-62.png';
import teacherAvatar63 from '../assets/images/avatars/teacher/teacher-avatar-63.png';
import teacherAvatar64 from '../assets/images/avatars/teacher/teacher-avatar-64.png';
import teacherAvatar65 from '../assets/images/avatars/teacher/teacher-avatar-65.png';
import teacherAvatar66 from '../assets/images/avatars/teacher/teacher-avatar-66.png';
import teacherAvatar67 from '../assets/images/avatars/teacher/teacher-avatar-67.png';
import teacherAvatar68 from '../assets/images/avatars/teacher/teacher-avatar-68.png';
import teacherAvatar69 from '../assets/images/avatars/teacher/teacher-avatar-69.png';
import teacherAvatar70 from '../assets/images/avatars/teacher/teacher-avatar-70.png';
import teacherAvatar71 from '../assets/images/avatars/teacher/teacher-avatar-71.png';
import teacherAvatar72 from '../assets/images/avatars/teacher/teacher-avatar-72.png';
import teacherAvatar73 from '../assets/images/avatars/teacher/teacher-avatar-73.png';

// מפת אווטרים של תלמידים
const STUDENT_AVATARS: Record<number, string> = {
    1: studentAvatar1,
    2: studentAvatar2,
    3: studentAvatar3,
    4: studentAvatar4,
    5: studentAvatar5,
    6: studentAvatar6,
    7: studentAvatar7,
    8: studentAvatar8,
    9: studentAvatar9,
    10: studentAvatar10,
    11: studentAvatar11,
    12: studentAvatar12,
    13: studentAvatar13,
    14: studentAvatar14,
    15: studentAvatar15,
    16: studentAvatar16,
    17: studentAvatar17,
    18: studentAvatar18,
    19: studentAvatar19,
    20: studentAvatar20,
    21: studentAvatar21,
    22: studentAvatar22,
};

// מפת אווטרים של מורים (כולל זכרים ונקבות)
const TEACHER_AVATARS: Record<number, string> = {
    1: teacherAvatar1,
    2: teacherAvatar2,
    3: teacherAvatar3,
    4: teacherAvatar4,
    5: teacherAvatar5,
    6: teacherAvatar6,
    7: teacherAvatar7,
    8: teacherAvatar8,
    9: teacherAvatar9,
    10: teacherAvatar10,
    11: teacherAvatar11,
    12: teacherAvatar12,
    13: teacherAvatar13,
    14: teacherAvatar14,
    15: teacherAvatar15,
    16: teacherAvatar16,
    17: teacherAvatar17,
    18: teacherAvatar18,
    19: teacherAvatar19,
    20: teacherAvatar20,
    21: teacherAvatar21,
    22: teacherAvatar22,
    23: teacherAvatar23,
    24: teacherAvatar24,
    25: teacherAvatar25,
    26: teacherAvatar26,
    27: teacherAvatar27,
    28: teacherAvatar28,
    29: teacherAvatar29,
    30: teacherAvatar30,
    31: teacherAvatar31,
    32: teacherAvatar32,
    33: teacherAvatar33,
    34: teacherAvatar34,
    35: teacherAvatar35,
    36: teacherAvatar36,
    37: teacherAvatar37,
    38: teacherAvatar38,
    39: teacherAvatar39,
    40: teacherAvatar40,
    41: teacherAvatar41,
    42: teacherAvatar42,
    43: teacherAvatar43,
    44: teacherAvatar44,
    45: teacherAvatar45,
    46: teacherAvatar46,
    47: teacherAvatar47,
    48: teacherAvatar48,
    49: teacherAvatar49,
    50: teacherAvatar50,
    51: teacherAvatar51,
    52: teacherAvatar52,
    53: teacherAvatar53,
    54: teacherAvatar54,
    55: teacherAvatar55,
    56: teacherAvatar56,
    57: teacherAvatar57,
    58: teacherAvatar58,
    59: teacherAvatar59,
    60: teacherAvatar60,
    61: teacherAvatar61,
    62: teacherAvatar62,
    63: teacherAvatar63,
    64: teacherAvatar64,
    65: teacherAvatar65,
    66: teacherAvatar66,
    67: teacherAvatar67,
    68: teacherAvatar68,
    69: teacherAvatar69,
    70: teacherAvatar70,
    71: teacherAvatar71,
    72: teacherAvatar72,
    73: teacherAvatar73,
};

// מפת אווטרים של אדמין (משתמשת בתמונות של מורים)
const ADMIN_AVATARS: Record<number, string> = {
    1: teacherAvatar1,
    2: teacherAvatar2,
    3: teacherAvatar3,
    4: teacherAvatar4,
    5: teacherAvatar5,
    6: teacherAvatar6,
    7: teacherAvatar7,
    8: teacherAvatar8,
    9: teacherAvatar9,
    10: teacherAvatar10,
    11: teacherAvatar11,
    12: teacherAvatar12,
    13: teacherAvatar13,
    14: teacherAvatar14,
    15: teacherAvatar15,
    16: teacherAvatar16,
    17: teacherAvatar17,
    18: teacherAvatar18,
    19: teacherAvatar19,
    20: teacherAvatar20,
    21: teacherAvatar21,
    22: teacherAvatar22,
    23: teacherAvatar23,
    24: teacherAvatar24,
    25: teacherAvatar25,
    26: teacherAvatar26,
    27: teacherAvatar27,
    28: teacherAvatar28,
    29: teacherAvatar29,
    30: teacherAvatar30,
    31: teacherAvatar31,
    32: teacherAvatar32,
    33: teacherAvatar33,
    34: teacherAvatar34,
    35: teacherAvatar35,
    36: teacherAvatar36,
    37: teacherAvatar37,
    38: teacherAvatar38,
    39: teacherAvatar39,
    40: teacherAvatar40,
    41: teacherAvatar41,
    42: teacherAvatar42,
    43: teacherAvatar43,
    44: teacherAvatar44,
    45: teacherAvatar45,
    46: teacherAvatar46,
    47: teacherAvatar47,
    48: teacherAvatar48,
    49: teacherAvatar49,
    50: teacherAvatar50,
    51: teacherAvatar51,
    52: teacherAvatar52,
    53: teacherAvatar53,
    54: teacherAvatar54,
    55: teacherAvatar55,
    56: teacherAvatar56,
    57: teacherAvatar57,
    58: teacherAvatar58,
    59: teacherAvatar59,
    60: teacherAvatar60,
    61: teacherAvatar61,
    62: teacherAvatar62,
    63: teacherAvatar63,
    64: teacherAvatar64,
    65: teacherAvatar65,
    66: teacherAvatar66,
    67: teacherAvatar67,
    68: teacherAvatar68,
    69: teacherAvatar69,
    70: teacherAvatar70,
    71: teacherAvatar71,
    72: teacherAvatar72,
    73: teacherAvatar73,
};

// מפת אווטרים של פרינסיפל (משתמשת בתמונות של מורים)
const PRINCIPAL_AVATARS: Record<number, string> = {
    1: teacherAvatar1,
    2: teacherAvatar2,
    3: teacherAvatar3,
    4: teacherAvatar4,
    5: teacherAvatar5,
    6: teacherAvatar6,
    7: teacherAvatar7,
    8: teacherAvatar8,
    9: teacherAvatar9,
    10: teacherAvatar10,
    11: teacherAvatar11,
    12: teacherAvatar12,
    13: teacherAvatar13,
    14: teacherAvatar14,
    15: teacherAvatar15,
    16: teacherAvatar16,
    17: teacherAvatar17,
    18: teacherAvatar18,
    19: teacherAvatar19,
    20: teacherAvatar20,
    21: teacherAvatar21,
    22: teacherAvatar22,
    23: teacherAvatar23,
    24: teacherAvatar24,
    25: teacherAvatar25,
    26: teacherAvatar26,
    27: teacherAvatar27,
    28: teacherAvatar28,
    29: teacherAvatar29,
    30: teacherAvatar30,
    31: teacherAvatar31,
    32: teacherAvatar32,
    33: teacherAvatar33,
    34: teacherAvatar34,
    35: teacherAvatar35,
    36: teacherAvatar36,
    37: teacherAvatar37,
    38: teacherAvatar38,
    39: teacherAvatar39,
    40: teacherAvatar40,
    41: teacherAvatar41,
    42: teacherAvatar42,
    43: teacherAvatar43,
    44: teacherAvatar44,
    45: teacherAvatar45,
    46: teacherAvatar46,
    47: teacherAvatar47,
    48: teacherAvatar48,
    49: teacherAvatar49,
    50: teacherAvatar50,
    51: teacherAvatar51,
    52: teacherAvatar52,
    53: teacherAvatar53,
    54: teacherAvatar54,
    55: teacherAvatar55,
    56: teacherAvatar56,
    57: teacherAvatar57,
    58: teacherAvatar58,
    59: teacherAvatar59,
    60: teacherAvatar60,
    61: teacherAvatar61,
    62: teacherAvatar62,
    63: teacherAvatar63,
    64: teacherAvatar64,
    65: teacherAvatar65,
    66: teacherAvatar66,
    67: teacherAvatar67,
    68: teacherAvatar68,
    69: teacherAvatar69,
    70: teacherAvatar70,
    71: teacherAvatar71,
    72: teacherAvatar72,
    73: teacherAvatar73,
};

// פונקציה שמחזירה אווטר לפי ID
export const getAvatarById = (id: number, type: 'student' | 'teacher' | 'admin' | 'principal'): string | null => {
    let avatarMap: Record<number, string>;
    
    switch (type) {
        case 'student':
            avatarMap = STUDENT_AVATARS;
            break;
        case 'teacher':
            avatarMap = TEACHER_AVATARS;
            break;
        case 'admin':
            avatarMap = ADMIN_AVATARS;
            break;
        case 'principal':
            avatarMap = PRINCIPAL_AVATARS;
            break;
        default:
            return null;
    }
    
    return avatarMap[id] || null;
};

// פונקציה שמחזירה את כל האווטרים של סוג מסוים
export const getAvatarsByType = (type: 'student' | 'teacher' | 'admin' | 'principal'): Array<{id: number, src: string}> => {
    let avatarMap: Record<number, string>;
    
    switch (type) {
        case 'student':
            avatarMap = STUDENT_AVATARS;
            break;
        case 'teacher':
            avatarMap = TEACHER_AVATARS;
            break;
        case 'admin':
            avatarMap = ADMIN_AVATARS;
            break;
        case 'principal':
            avatarMap = PRINCIPAL_AVATARS;
            break;
        default:
            return [];
    }
    
    return Object.entries(avatarMap).map(([id, src]) => ({
        id: parseInt(id),
        src: src
    }));
};

// פונקציה שמחזירה את כל האווטרים
export const getAllAvatars = (): { 
    student: Array<{id: number, src: string}>, 
    teacher: Array<{id: number, src: string}>,
    admin: Array<{id: number, src: string}>,
    principal: Array<{id: number, src: string}>
} => {
    return {
        student: getAvatarsByType('student'),
        teacher: getAvatarsByType('teacher'),
        admin: getAvatarsByType('admin'),
        principal: getAvatarsByType('principal')
    };
}; 